<template>
	<section>
		<article class='project__info'>
			<slot name='title'></slot>
			<slot name='info'></slot>
			<slot name='links'></slot>
		</article>
		<slot name='images'></slot>
	</section>
</template>

<script>
export default {
	name: 'Project'
}
</script>